export class FavoritesStorage {
  private static KEY = 'wildrift-favorites';

  static getFavorites(): string[] {
    try {
      const stored = localStorage.getItem(this.KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.warn('localStorage unavailable, favorites disabled', error);
      return [];
    }
  }

  static addFavorite(championId: string): void {
    const favorites = this.getFavorites();
    if (!favorites.includes(championId)) {
      favorites.push(championId);
      localStorage.setItem(this.KEY, JSON.stringify(favorites));
      // Dispatch event to notify components (e.g., Navigation)
      window.dispatchEvent(new Event('favoritesChanged'));
    }
  }

  static removeFavorite(championId: string): void {
    const favorites = this.getFavorites().filter(id => id !== championId);
    localStorage.setItem(this.KEY, JSON.stringify(favorites));
    // Dispatch event to notify components (e.g., Navigation)
    window.dispatchEvent(new Event('favoritesChanged'));
  }

  static isAvailable(): boolean {
    try {
      const test = '__ls_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch {
      return false;
    }
  }
}
